var map = {
	"./logo_tspace_sourcing-1.png": 807,
	"./logo_tspace_sourcing.png": 808,
	"./sample-logo.png": 809,
	"./sample-logo.svg": 810,
	"./t-space-logo.png": 811,
	"./t-space-logo.svg": 812
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 806;